import { render, staticRenderFns } from "./ImportacionDestinos.vue?vue&type=template&id=b56ac1ee&"
import script from "./ImportacionDestinos.vue?vue&type=script&lang=js&"
export * from "./ImportacionDestinos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports